<div class="header-container">
    <h1>Assets Management</h1>

    <button class="add-btn" nz-button nzType="primary" nzDanger nzSize="large"
        (click)="openAssetModal(tplContent, tplFooter)">
        <span nz-icon nzType="plus"></span>
        Add new asset
    </button>
</div>
<div class="content">
    @for (asset of uploadedAssets; track asset.url) {
    <div class="uploaded-asset">
        @if (asset.assetType === 'logos' || asset.assetType === 'icons') {
        <img [src]="asset.url" [alt]="asset.name" />
        }
        <div class="uploaded-asset-url">
            <a [href]="asset.url" target="_blank" rel="noopener noreferrer">{{ asset.url }}</a>
        </div>
    </div>
    }
</div>

<ng-template #tplContent>
    <form class="asset-form" nz-form nzLayout="vertical" [formGroup]="assetForm">
        <nz-form-item>
            <nz-form-label nzRequired>Scope</nz-form-label>
            <nz-form-control>
                <nz-select formControlName="scope">
                    <nz-option nzValue="shared" nzLabel="Shared"></nz-option>
                    <nz-option nzValue="defaults" nzLabel="Defaults"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label nzRequired>Target app</nz-form-label>
            <nz-form-control>
                <nz-select formControlName="app">
                    <nz-option nzValue="admin-tool" nzLabel="Admin tool"></nz-option>
                    <nz-option nzValue="platform" nzLabel="Platform"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label nzRequired>Asset type</nz-form-label>
            <nz-form-control>
                <nz-select formControlName="asset_type">
                    <nz-option nzValue="logos" nzLabel="Logo"></nz-option>
                    <nz-option nzValue="documents" nzLabel="Document"></nz-option>
                    <nz-option nzValue="icons" nzLabel="Icon"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
        <div class="row">
            <nz-form-item>
                <nz-form-label nzRequired>File</nz-form-label>
                <nz-form-control>
                    <input type="file" [accept]="acceptedFileTypes" [disabled]="isUploading"
                        (change)="onFileSelected($event)" #fileInput />
                    <div class="selected-file" *ngIf="selectedFile">Size: ({{ formatFileSize(selectedFile.size) }})
                    </div>
                </nz-form-control>
            </nz-form-item>
            @if(showPreview) {
            <div class="asset-preview">
                <img [src]="previewUrl" [alt]="selectedFile?.name || 'Asset preview'" />
            </div>
            }
        </div>
        <div class="row">
            <nz-form-item>
                <nz-form-label>URL part</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="url_part">
                        <nz-option nzValue="" nzLabel="None"></nz-option>
                        <nz-option nzValue="group_id" nzLabel="group_id"></nz-option>
                        <nz-option nzValue="customer_id" nzLabel="customer_id"></nz-option>
                        <nz-option nzValue="vehicle_brand" nzLabel="vehicle_brand"></nz-option>
                        <nz-option nzValue="customer_name" nzLabel="customer_name"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <span>/</span>
            <nz-form-item>
                <nz-form-label nzRequired>Key part</nz-form-label>
                <nz-form-control nzErrorTip="Enter relative path">
                    <input nz-input formControlName="key_path" placeholder="bmw.png" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div class="key">
            <span>Key path:</span>
            @if(assetForm.controls.key_path.value) {
            <span class="key-path">
                {{buildKeyPath(assetForm.getRawValue().url_part, assetForm.getRawValue().key_path)}}
            </span>
            }
        </div>
        <nz-progress *ngIf="isUploading" [nzPercent]="uploadProgress" nzStatus="active"></nz-progress>
    </form>
</ng-template>

<ng-template #tplFooter let-ref="modalRef">
    <button nz-button [disabled]="isUploading" (click)="ref.close()">Cancel</button>
    <button nz-button nzType="primary" [nzLoading]="isUploading" [disabled]="!canUpload" (click)="uploadAsset(ref)">
        Upload asset
    </button>
</ng-template>